import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/user.store';
import { useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';
import { useBuyboxLoggedInExp } from '@/components/experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';
import { faTimes, faInfoCircle, faTableCells, faList } from '@fortawesome/free-solid-svg-icons';
import { TitleDetail } from '@/interfaces/title-details-graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null,
    title: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
	title: TitleDetail;
};





const {
	newBuyboxTooltipAcknowledged,
	setNewBuyboxTooltipAcknowledged,
	newBuyboxView,
	setNewBuyboxView,
	isUserFirstVisit,
	isLoggedIn,
	loggedInNewBuyboxView,
} = useUserStore();

const { t } = useI18n();
const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();

const buyboxView = computed(() => {
	if (!!props.buyBoxType) {
		return props.buyBoxType;
	}

	if (isLoggedIn.value && (props.title.__typename === 'Season' || props.title.__typename === 'Show')) {
		return loggedInNewBuyboxView.value;
	}

	return newBuyboxView.value;
});

const showTooltip = computed(() => {
	if (isLoggedIn.value) {
		return !newBuyboxTooltipAcknowledged.value;
	}
	return !newBuyboxTooltipAcknowledged.value && isUserFirstVisit.value === false;
});

const handleListClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		setNewBuyboxView(NewBuyBoxView.LIST);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.LIST);
};

const handleGridClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		setNewBuyboxView(NewBuyBoxView.GRID);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
};

const trackToggleEvent = (label: NewBuyBoxView) => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
	trackBuyboxLoggedInExp({
		action: 'click',
		label: `buybox_view_clicked_${label}`,
	});
};

const close = () => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	setNewBuyboxTooltipAcknowledged();
};

return { __sfc: true,props, emit, newBuyboxTooltipAcknowledged, setNewBuyboxTooltipAcknowledged, newBuyboxView, setNewBuyboxView, isUserFirstVisit, isLoggedIn, loggedInNewBuyboxView, t, trackBuyboxLoggedInExp, buyboxView, showTooltip, handleListClicked, handleGridClicked, trackToggleEvent, close, faTimes, faInfoCircle, faTableCells, faList }
}

})